import type { SVGProps } from "react";

export const Square = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    style={{}}
    version="1.1"
    viewBox="0 0 181.9 181.9"
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    y="0px"
    {...props}
  >
    <title>Square</title>

    <g>
      <g>
        <g>
          <path
            d="M151.5,0H30.4C13.6,0,0,13.6,0,30.4v121.1c0,16.8,13.6,30.4,30.4,30.4h121.1c16.8,0,30.4-13.6,30.4-30.4
				V30.4C181.9,13.6,168.3,0,151.5,0z M148.8,139.3c0,5.3-4.3,9.6-9.6,9.6H42.7c-5.3,0-9.6-4.3-9.6-9.6V42.7c0-5.3,4.3-9.6,9.6-9.6
				h96.6c5.3,0,9.6,4.3,9.6,9.6V139.3z"
            style={{ fill: "currentColor" }}
          />
          <path
            d="M71.7,115.6c-3.1,0-5.5-2.5-5.5-5.5V71.6c0-3.1,2.5-5.5,5.5-5.5h38.6c3,0,5.5,2.5,5.5,5.5v38.5
				c0,3.1-2.5,5.5-5.5,5.5H71.7z"
            style={{ fill: "currentColor" }}
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Square;
